<a [routerLink]="model.data.url"
  class="flex flex-column height-100">
  <!-- image -->
  <div class="w-12 ratio-3-2 overflow-hidden">
    <shell></shell>
    <img class="rf"
      [image]="model.data.image"
      [attr.alt]="model.data.name">
  </div>

  <div class="center bg-col-w p-r-5 p-b-3 p-l-2-s p-r-4-s p-r-4-m flex-grow flex flex-column flex-top">
    <!-- tags -->
    @if (tagCategories?.length) {
      <ul class="p-t-5 p-t-4-s"
        >
        @for (tag of tagCategories; track $index; let first = $first) {
          <li
            [class.m-l-1]="!first"
            class="c1 col-1 bg-col-5 p-l-2 p-r-2 p-a-1 _tag inline-block">
            {{tag.name | uppercase}}
          </li>
        }
      </ul>
    }
    <!-- inner part -->
    <div class="flex-grow">
      <!-- title -->
      <p class="h2 m-b-1 m-b-3-s m-t-4-s left">
        {{model.name}}
      </p>
      <!-- Date -->
      @if (typeData?.date) {
        <div class="p1 col-1 m-t-2 flex m-l-1-s"
          >
          <p>{{typeData?.date | date: 'MMMM dd, yyyy'}}</p>
          @if (typeData?.date && typeData.reading_time) {
            &nbsp;|&nbsp;
          }
          <p>{{typeData.reading_time}}</p>
          <i class="icon-clock _clock m-l-2"></i>
        </div>
      }
    </div>
    <!-- Read more -->
    <div>
      <action class="m-t-3 button-inline p-t-3">
        <span>Read article</span>
      </action>
    </div>
  </div>
</a>